import { render, staticRenderFns } from "./HirayaMessage.vue?vue&type=template&id=26a80ab0&scoped=true&"
var script = {}
import style0 from "./HirayaMessage.vue?vue&type=style&index=0&id=26a80ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a80ab0",
  null
  
)

export default component.exports